import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import BigImage from '../../components/BigImage'
import Card from '../../components/Card'
import Header from '../../components/Header'
import Paginate from '../../components/Paginate'
import Prompts from '../../components/Prompts'
import SectionHeader from '../../components/SectionHeader'
import Slider from '../../components/Slider'
import Stories from '../../components/Stories'
import SummaryBullet from '../../components/SummaryBullet'
import Text from '../../components/Text'
import patient from '../../stores/patient'
import getStoryPatientName from '../../utils/getStoryPatientName'
import MotivationToggles from './MotivationToggles'
import PostStrengthsPrompts1 from './PostStrengthsPrompts1'
import StrengthToggles from './StrengthToggles'
import Survey from './Survey'

@observer
export default class GoalSession1 extends Component {
  render() {
    const { demo } = this.props
    const storyPatientName = getStoryPatientName()

    return (
      <Fragment>
        {/* SURVEY */}
        <SectionHeader color="red" icon="fas fa-list" str="titles.survey" />
        <Survey />
        {/* MOTIVATIONS */}
        <SectionHeader color="red" icon="fas fa-handshake" str="titles.motivations" />
        {/* MOTIVATIONS - IMPORTANCE RULER */}
        <Header str="titles.importanceRuler" />
        <Prompts>
          <Prompts.S str="prose.maintainingYourVision" />
        </Prompts>
        <BigImage src="/images/family-hugging.jpg" />
        <Card>
          <Card.Title str="prose.howImportant" />
          <Card.Pad>
            <Slider
              min={1}
              max={10}
              pinColor="red"
              value={patient.fields.importance}
              onChange={patient.setImportance}
            />
          </Card.Pad>
        </Card>
        <Prompts>
          {patient.fields.importance > 1 &&
            <Prompts.Q
              str="prose.whatPutsYouAtA"
              inserts={{
                firstNum: patient.fields.importance,
                secondNum: patient.fields.importance <= 2 ? 1 : patient.fields.importance - 2,
              }}
            />
          }
          <Prompts.R str="prose.itSoundsLike" />
        </Prompts>
        {patient.fields.importance < 7 &&
          <Fragment>
            {/* MOTIVATIONS - I'M MOTIVATED BY ... */}
            <Header str="titles.imMotivatedBy" />
            <Prompts>
              <Prompts.P str="prose.foundThatPeople" />
              {patient.fields.lowVision==="YES"? <Prompts.P str="prose.belowIsAListLowVision"/>:<Prompts.P str="prose.belowIsAList" />}
            </Prompts>
            <MotivationToggles />
            <Prompts>
              <Prompts.Q str="prose.youValueBeing" />
              <Prompts.R str="prose.itSoundsLike" />
            </Prompts>
          </Fragment>
        }
        {/* STRENGTHS */}
        <SectionHeader color="red" icon="fas fa-heart" str="titles.strengths" />
        {/* STRENGTHS - CONFIDENCE RULER */}
        <Header str="titles.confidenceRuler" />
        <Prompts>
          <Prompts.Q str="prose.youDecidedYouWanted" />
        </Prompts>
        <BigImage src="/images/roadmap.jpg" />
        <Card>
          <Card.Title str="prose.howConfident" />
          <Card.Pad>
            <Slider
              min={1}
              max={10}
              pinColor="red"
              value={patient.fields.confidence}
              onChange={patient.setConfidence}
            />
          </Card.Pad>
        </Card>
        <Prompts>
          {patient.fields.confidence > 1 &&
            <Prompts.Q
              str="prose.whatPutsYouAtA"
              inserts={{
                firstNum: patient.fields.confidence,
                secondNum: patient.fields.confidence <= 2 ? 1 : patient.fields.confidence - 2,
              }}
            />
          }
          <Prompts.R str="prose.youreAtABecauseYouKnow" inserts={{ num: patient.fields.confidence }} />
          {patient.fields.confidence < 10 &&
            <Prompts.Q
              str="prose.whatWouldHelpImprove"
              inserts={{
                firstNum: patient.fields.confidence,
                secondNum: patient.fields.confidence >= 8 ? 10 : patient.fields.confidence + 2,
              }}
            />
          }
          {patient.fields.confidence < 10 &&
            <Prompts.R str="prose.haveSomeIdeas" />
          }
        </Prompts>
        {patient.fields.confidence < 7 &&
          <Fragment>
            {/* STRENGTHS - MY STRENGTHS ARE ... */}
            <Header str="titles.myStrengthsAre" />
            <Prompts>
              {patient.fields.lowVision==="YES"?<Prompts.Q str="prose.thingsWeAreGoodAtLowVision" />:<Prompts.Q str="prose.thingsWeAreGoodAt" />}
            </Prompts>
            <StrengthToggles />
            <PostStrengthsPrompts1 />
          </Fragment>
        }
        {/* STORIES */}
        <SectionHeader color="red" icon="fas fa-users" str="titles.stories" />
        <Prompts>
          <Prompts.Q str="prose.youveMentionedAlready" />
          <Prompts.R str="prose.mainThingsThatGet" />
          <Prompts.Q str="prose.ideaAddressBarrier" />
          <Prompts.R str="prose.imagineTryingIdeas" />
          {patient.fields.gender === 'MALE' &&
            <Prompts.P str="prose.shareSomeWaysThatMale" inserts={{ name: storyPatientName }} />
          }
          {patient.fields.gender === 'FEMALE' &&
            <Prompts.P str="prose.shareSomeWaysThatFemale" inserts={{ name: storyPatientName }} />
          }
        </Prompts>
        <BigImage src={patient.ethnicityImage} />
        <Stories />
        {/* SUMMARY */}
        <SectionHeader color="red" icon="fas fa-users" str="titles.summary" />
        {/* <Prompts>
          <Prompts.S str="prose.toSummarizeGoal" inserts={{ name: storyPatientName }} />
        </Prompts> */}
        <SummaryBullet
          color="red"
          icon={(
            (patient.fields.importance >= 7 && 'fas fa-smile') ||
            (patient.fields.importance >= 4 && 'fas fa-meh') ||
            'fas fa-frown'
          )}
        >
          <Text str="prose.importanceOfTakingDrops" />
          {` ${patient.fields.importance} / 10`}
        </SummaryBullet>
        <SummaryBullet
          color="red"
          icon={(
            (patient.fields.confidence >= 7 && 'fas fa-smile') ||
            (patient.fields.confidence >= 4 && 'fas fa-meh') ||
            'fas fa-frown'
          )}
        >
          <Text str="prose.confidenceCanImprove" />
          {` ${patient.fields.confidence} / 10`}
        </SummaryBullet>
        {patient.fields.importance < 7 && patient.hasMotivations &&
          <SummaryBullet color="red" icon="fas fa-handshake">
            <Text str="prose.youreMotivatedBy" />&nbsp;
            {patient.fields.motivations.map((v, i) => (
              <Fragment key={i}>
                <Text str={`choices.motivation.${v}`} />
                {i !== patient.fields.motivations.length - 1 && ', '}
              </Fragment>
            ))}
          </SummaryBullet>
        }
        {patient.fields.confidence < 7 && patient.hasStrengths &&
          <SummaryBullet color="red" icon="fas fa-heart">
            <Text str="prose.yourStrengthsAre" />&nbsp;
            {patient.fields.strengths.map((v, i) => (
              <Fragment key={i}>
                <Text str={`choices.strength.${v}`} />
                {i !== patient.fields.strengths.length - 1 && ', '}
              </Fragment>
            ))}
          </SummaryBullet>
        }
        <Prompts>
          <Prompts.Q str="prose.lastSectionToReview" />
        </Prompts>
        {/* PAGINATE */}
        {!demo &&
          <Paginate>
            <Paginate.Button prev
              color="orange"
              str="titles.use"
              to={`/use/first/${patient.fields._id}`}
            />
            <Paginate.Button next
              color="purple"
              str="titles.plan"
              to={`/plan/first/${patient.fields._id}`}
            />
          </Paginate>
        }
        {demo &&
          <Paginate>
            <Paginate.Button prev
              color="orange"
              str="titles.use"
              to="/demo/use"
            />
            <Paginate.Button next
              color="purple"
              str="titles.plan"
              to="/demo/plan"
            />
          </Paginate>
        }
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/GoalSession1.js